import * as React from 'react'
import { UserDocument } from '../lib/userDocuments.slice'
import {
  DocumentsSearchBar,
  DocumentSearchBarOnChangeData,
} from './DocumentsSearchBar'

interface DocumentsToolbarProps {
  children?: React.ReactNode
  documents: UserDocument[]
  onSearch: (_data: DocumentSearchBarOnChangeData) => void
  rightElement?: React.ReactNode
}

export const TabPaneToolbar: React.FC<DocumentsToolbarProps> = ({
  children,
  documents,
  onSearch,
  rightElement,
}) => {
  return (
    <div className="flex flex-col space-y-6">
      <div className="flex flex-row flex-wrap items-center gap-2">
        <div className="flex-1 min-w-0 max-w-[500px]">
          <DocumentsSearchBar documents={documents} onChange={onSearch} />
        </div>
        <div className="ml-auto shrink-0 w-full sm:w-auto">{rightElement}</div>
      </div>

      {children && <div className="flex flex-col gap-4">{children}</div>}
    </div>
  )
}
